<div class="content">
    <div class="manifesto-copy">
        <p class="kicker" showup>What guides us</p>
        <h2 showup [showDelay]="80">Performance should feel personal, not performative.</h2>
    </div>
    <p showup [showDelay]="160">Veyora Fit is built for women who want activewear with presence but no noise. We care
        about the small decisions that change how a piece feels at 7 AM, during a deep stretch, on a long walk, and
        while moving through an ordinary beautiful day.</p>
</div>
